export const TABELA_ALINHAMENTO = [
  {'pt': 'esquerda', 'en': 'left', 'nome': 'Esquerda'}, 
  {'pt': 'centro', 'en': 'center', 'nome': 'Centro'}, 
  {'pt': 'direita', 'en': 'right', 'nome': 'Direita'}, 
];